// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"d5c772a2513cde9aaf07","223":"364e68a57e135e470bdd","293":"ee8b28c635a6bb22c700"}[chunkId] + ".js";
};